/**
 * A modified base button (from ux repo) with the addition of
 * - loading state
 * - consistent padding and font size
 */
import { Loader2Icon } from 'lucide-react';
import { ComponentProps } from 'react';
import { Button as OrigButton } from '@repo/ux/button';
import { cn } from '@repo/ux/lib/utils';

// export * from '@repo/ux/button';

type ButtonProps = ComponentProps<typeof OrigButton> & {
  loading?: boolean;
  children: React.ReactNode;
};
export function Button({
  loading,
  children,
  className,
  asChild,
  ...props
}: ButtonProps) {
  if (asChild) {
    return (
      <OrigButton
        asChild
        className={cn('px-4 py-3 text-sm font-medium h-auto', className)}
        {...props}
      >
        {children}
      </OrigButton>
    );
  }

  return (
    <OrigButton
      className={cn('px-4 py-3 text-sm font-medium h-auto', className)}
      {...props}
      disabled={props.disabled || loading}
    >
      <span className="inline-flex items-center gap-2">
        {loading && (
          <Loader2Icon className="animate-spin size-4" strokeWidth="4" />
        )}
        {children}
      </span>
    </OrigButton>
  );
}
